import axios from 'axios'
const API = '/api/brake-adjustments'

export function BrakeAdjustment(params = {}, method = 'get', subpath) {
  var url = params.id ? API + '/' + params.id : API
  url = subpath ? url + '/' + subpath : url

  return axios({
    url: url,
    method: method,
    params
  })
}
